import { Link } from 'react-router-dom'
import { EmptyState } from '../components/ui/EmptyState'
import { Button } from '../components/ui/Button'

export function NotFoundPage() {
  return (
    <EmptyState
      mascot
      title="Seite nicht gefunden"
      description="Diese Seite existiert nicht oder wurde noch nicht gebaut."
      action={
        <Link to="/">
          <Button variant="secondary">Zum Dashboard</Button>
        </Link>
      }
    />
  )
}
